import image from "../../img/lol6.png";
import React from "react";
import { All, Button, LP, PP } from "./Style";
function Slavs() {
  return (
    <All>
      <LP zrodlo={image} style={{ backgroundPosition: 0 }}></LP>
      <PP>
        <h1>Niepotrzebnie długi film o stalkerze</h1>
        <p>
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500.
        </p>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.youtube.com/watch?v=kDQnQq_zeps"
        >
          <Button>Obejrzyj</Button>
        </a>
      </PP>
    </All>
  );
}

export default Slavs;
